import type { Product } from '../../models/Product';
import type { SupabaseClient } from '@supabase/supabase-js';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, name, description, price_id, interval, interval_count, type, price, currency`;

export class ProductRepository extends SupabaseRepository<Product> {
  constructor(client: SupabaseClient) {
    super('products', selector, client);
  }
}
